import {
  DatePicker,
  Form,
  Button,
  Tag,
  Popover,
  InputNumber,
  Row,
  Col,
  Space,
  Typography
} from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import FocusSafeInput from "../FocusSafeInput";

const { Title } = Typography;

const EventSubForm = ({
  title = "Add a Rental",
  values = {},
  minStartDate,
  maxEndDate,
  onClick,
  text = 'Add'
}) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const content = (
    <div
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Form
        form={form}
        onFinish={(values) => {
          form.validateFields().then(() => {
            const payload = {
              ...values,
              startDate: values.startDate?.toISOString(),
              endDate: values.endDate?.toISOString(),
            };
            onClick(payload);
            setOpen(false);
          });
        }}
        layout="vertical"
        initialValues={{
          quantity: 1,
          ...values,
          startDate: values.startDate ? dayjs(values.startDate) : null,
          endDate: values.endDate ? dayjs(values.endDate) : null,
        }}
        style={{ minWidth: 520 }}
      >
        <Title level={5} style={{ marginBottom: 16 }}>
          {title}
        </Title>

        {/* Row 1 */}
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: 'Please select start date' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                minDate={minStartDate ? dayjs(minStartDate) : undefined}
                maxDate={maxEndDate ? dayjs(maxEndDate) : undefined}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="End Date"
              name="endDate"
              dependencies={["startDate"]}
              rules={[
                { required: true, message: 'Please select end date' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const startDate = getFieldValue('startDate');
                    if (!value || !startDate || value.isAfter(startDate) || value.isSame(startDate)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('End date must be after start date'));
                  },
                }),
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                minDate={
                  form.getFieldValue("startDate") ||
                  (minStartDate ? dayjs(minStartDate) : undefined)
                }
                maxDate={maxEndDate ? dayjs(maxEndDate) : undefined}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Row 2 */}
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              label="Quantity"
              name="quantity"
              rules={[{ required: true, message: 'Please enter quantity' }]}
            >
              <FocusSafeInput
                placeholder="Quantity"
                type="number"
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[{ required: true, message: 'Please enter amount' }]}
            >
              <FocusSafeInput
                placeholder="Amount"
                type="number"
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Space style={{ float: "right" }}>
            <Button size="small" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button size="small" type="primary" htmlType="submit">
              {text}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="left"
      content={content}
    >
      <span style={{ float: "right", cursor: "pointer" }}>
        <Tag color="orange">{text}</Tag>
      </span>
    </Popover>
  );
};

export default EventSubForm;
